<template>
<div class="monitor-container">
    <Row type="flex">
        <!-- 输入状态 -->
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('r028') }}</div>
            <Row class="flex">
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a114') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[0].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[0].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[7].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[7].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[4].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[4].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[1].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[1].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[6].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[6].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[9].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[9].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[11].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[11].labelKey) }}</div>
                        </Col>
                    </Row>

                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a126') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[8].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[8].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[14].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[14].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[15].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[15].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[13].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[13].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[10].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[10].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[21].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[21].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[23].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[23].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[19].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[19].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[17].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[17].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a177') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[29].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[29].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex" class="normal-hover">
                        <Col flex="1">
                        <div :class="['my-custom-dot', inputRows[31].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[31].labelKey) }}</div>
                        </Col>
                    </Row>

                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a178') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[25].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[25].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[27].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[27].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>

            </Row>
            <Row type="flex">
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a161') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[34].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[34].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[36].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[36].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[32].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[32].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[33].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[33].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[35].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[35].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[37].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[37].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[39].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[39].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a162') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[42].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[42].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[44].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[44].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[40].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[40].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[41].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[41].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[43].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[43].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[45].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[45].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[47].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[47].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a145') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', inputRows[2].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(inputRows[2].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                </Col>
            </Row>

        </Card>
        </Col>
        <!-- 输出状态 -->
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('r029') }}</div>
             <Row class="flex">
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a179') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[35].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[35].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[11].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[11].labelKey) }}</div>
                        </Col>
                    </Row>
                     <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[13].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[13].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[15].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[15].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[9].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[9].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[8].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[8].labelKey) }}</div>
                        </Col>
                    </Row>
                      <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[10].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[10].labelKey) }}</div>
                        </Col>
                    </Row>
                     <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[14].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[14].labelKey) }}</div>
                        </Col>
                    </Row>
                     <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[12].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[12].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a161') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[25].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[25].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[24].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[24].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a162') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[27].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[27].labelKey) }}</div>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[26].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[26].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col flex="1">
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">{{ getTranslation('a145') }}</legend>
                    <Row type="flex">
                        <Col flex="1" class="normal-hover">
                        <div :class="['my-custom-dot', outputRows[38].val ? 'custom-error' : 'custom-default']"></div>
                        <div class="custom-label">{{ getTranslation(outputRows[38].labelKey) }}</div>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
            </Row>           
        </Card>
        </Col>
    </Row>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import {
    int16toBit
} from '@/util/util'

export default {
    name: 'IoStatus',
    components: {},
    props: {
        runningData: Object,
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        // 输入: StDiX1X0(bits 0-15), StDiX3X2(bits 16-31), StDiX5X4(bits 32-47), StDiX7X6(bits 48-63)
        inputBits() {
            const fields = ['StDiX1X0', 'StDiX3X2', 'StDiX5X4', 'StDiX7X6']
            let bits = []
            fields.forEach(field => {
                const val = this.runningData && this.runningData[field] != null ? this.runningData[field] : 0
                bits = bits.concat(int16toBit(val))
            })
            return bits
        },
        // 输出: StDoQ1Q0(bits 0-15), StDoQ3Q2(bits 16-31), StDoQ5Q4(bits 32-47)
        outputBits() {
            const fields = ['StDoQ1Q0', 'StDoQ3Q2', 'StDoQ5Q4']
            let bits = []
            fields.forEach(field => {
                const val = this.runningData && this.runningData[field] != null ? this.runningData[field] : 0
                bits = bits.concat(int16toBit(val))
            })
            return bits
        },
        // 统一行数：取输入/输出最大位数对齐
        totalBits() {
            return Math.max(this.inputBits.length, this.outputBits.length)
        },
        inputRows() {
            const rows = []
            let totalBits = this.inputBits.length;
            for (let i = 0; i < totalBits; i += 1) {
                const row = {
                    val: i < this.inputBits.length ? this.inputBits[i] : 0,
                    labelKey: this.getTranslation(this.inputLabels[i])
                }
                rows.push(row)
            }            
            return rows
        },
        outputRows() {
            const rows = []
            let totalBits = this.outputBits.length;
            for (let i = 0; i < totalBits; i += 1) {
                const row = {
                    val: i < this.outputBits.length ? this.outputBits[i] : 0,
                    labelKey: this.getTranslation(this.outputLabels[i])
                }              
                rows.push(row)
            }
            return rows
        },
        inputLabels() {
            return [
                // StDiX1X0  (bit 0-15)
                'a023', 'a024', 'a025', 'a026', 'a027', 'a028', 'a029', 'a030',
                'c015', 'a031', 'a032', 'a033', 'a034', 'a035', 'a036', 'a037',
                // StDiX3X2  (bit 16-31)
                'r047', 'a038', 'r047', 'a039', 'r047', 'a040', 'r047', 'a041',
                'a042', 'a043', 'a044', 'a045', 'a046', 'a047', 'a048', 'a049',
                // StDiX5X4  (bit 32-47)
                'a050', 'a051', 'a052', 'a053', 'a054', 'a055', 'r047', 'a056',
                'a057', 'a058', 'a059', 'a060', 'a061', 'a062', 'r047', 'a063',
                // StDiX7X6  (bit 48-63)
                'a064', 'a065', 'a066', 'a067', 'a068', 'a069', 'r047', 'a070',
                'a071', 'a072', 'a073', 'a074', 'a075', 'a076', 'r047', 'a077',
            ];
        },
        outputLabels() {
            return [
                // StDoQ1Q0  (bit 0-15)
                'a078', 'a079', 'a080', 'a081', 'a082', 'a083', 'a084', 'a085',
                'a086', 'a087', 'a088', 'a089', 'a090', 'a091', 'a092', 'a093',
                // StDoQ3Q2  (bit 16-31)
                'a094', 'a095', 'a096', 'a097', 'a098', 'a099', 'a100', 'a101',
                'a102', 'a103', 'a104', 'a105', 'a106', 'a107', 'a108', 'a109',
                // StDoQ5Q4  (bit 32-47)
                'r047', 'r047', 'r047', 'a110', 'r047', 'a111', 'a112', 'a113',
                'r047', 'r047', 'r047', 'r047', 'r047', 'r047', 'r047', 'r047',
            ];
        }
    },
    methods: {},
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.my-custom-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 4px;
}

.custom-default {
    background-color: #e6ebf1;
}

.custom-error {
    background-color: #ed4014;
}

.custom-label {
    display: inline-block;
}

.table-row-odd {
    background-color: #f8f9fa;
}
.my-fieldset{
    margin-bottom:10px;
    margin-left:5px;

}
</style>
